module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/id/6-4514d81547209f1005726f7968b28866.jpg";